// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"StripeEdit_buttonsContainer__UrR2k","accountLink":"StripeEdit_accountLink__ytvE2","preloader":"StripeEdit_preloader__svH8x"};